
import { DeckShell } from "@/components/deck/DeckShell";
import type { DeckDef } from "@/decks/types";

// Recibe el deck ya resuelto (compilado + overlay de config) desde App.
export function DeckRoot({ deck }: { deck: DeckDef }) {
  return <DeckShell deck={deck} />;
}
